import React, { useState, Suspense, useEffect } from "react";
import "./Subscription.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Table } from "reactstrap";

import Skeleton from "@mui/material/Skeleton";

import Loading from "../../components/Loading";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import Footer from "../../DefaultLayout/Footer";

import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";

import { connect, useSelector } from "react-redux";

import {
  runningSubscription,
  dashboardSubscription,
  getUserSubscription,
  getCardType,
  getAllSubscription,
} from "../../actions/subscription";
import moment from "moment";
import swal from "sweetalert";
import PaymentModal from "../../View/Subscription/PaymentModal";

const Subscription_info = (props) => {
  const { auth, label } = props;
  const { frontLabelsName } = label;
  
  const [runningSub, setRunningSub] = useState("");
  const [extraSubscriptionDetails, setExtraSubscriptionDetails] = useState("");
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const subscribeHistory = useSelector((state) => state.subscription);
  const {
    subscription,
    loading,
    runningSubscription,
    allSubscription,
    allCards,
  } = subscribeHistory;
  const subsDetails = runningSubscription;
  const rows = subscription?.docs?.filter((val) => val.status !== 1);
  const userName = localStorage.getItem("user");

  const [card_type, setCardType] = useState("");



  useEffect(() => {
    if(auth?.user?.dayssince==0){
    props.getAllSubscription();
    }
  }, [auth?.user?.dayssince]);

  useEffect(() => {
    props.dashboardSubscription().then((res) => {
      setExtraSubscriptionDetails(res);
    });
    props.getUserSubscription(1,10);
  }, []);

  useEffect(() => {
    props.getCardType().then((res) => {
      let filteredData = res.filter(function (obj) {
        return (
          obj.type ===
          subsDetails?.result?.trans?.payment_data?.payment_method_data?.type
        );
      });
      setCardType(filteredData[0].name);
    });
  }, []);

  const InactiveCardType = (data) => {
    let filteredData;

    filteredData =
      !loading &&
      allCards &&
      allCards.length > 0 &&
      allCards.filter(function (obj) {
        return obj.type === data;
      });

    return filteredData && filteredData[0] && filteredData[0].name;
  };

  useEffect(() => {
    props.runningSubscription(userName);
  }, []);


 

  



  const getDays1 = (value) => {
    let result = moment(value)
      .startOf("seconds")
      .fromNow(true)
      .replace("days", "");
    if (result === "a day") {
      result = 1;
    }
    if (result === "an hour") {
      result = 1 + " hour";
    }

    return result;
  };
  // alert(diffDays)
  const handleSubscribe = (datas) => {
    const data = {
      plan_id: datas,
      user_id: userName,
    };
    swal({
      title: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_get_access_to_leigulistinn!").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_get_access_to_leigulistinn!")[0][
              "value"
            ] || "lbl_get_access_to_leigulistinn!"
          : "lbl_get_access_to_leigulistinn!"
        : "lbl_get_access_to_leigulistinn!",
      text: `${
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_subscription_amount_is")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_subscription_amount_is"
              )[0]["value"] || "lbl_subscription_amount_is"
            : "lbl_subscription_amount_is"
          : "lbl_subscription_amount_is"
      } ISK${allSubscription?.amount}`,
      icon: "info",
      buttons: [
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_cancel").length > 0
            ? frontLabelsName.filter((e) => e.key == "lbl_cancel")[0]["value"] ||
              "lbl_cancel"
            : "lbl_cancel"
          : "lbl_cancel",
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_continue").length > 0
            ? frontLabelsName.filter((e) => e.key == "lbl_continue")[0]["value"] ||
              "lbl_continue"
            : "lbl_continue"
          : "lbl_continue",
      ],
      dangerMode: true,
      className: "bg-button",
    }).then((willDelete) => {
      if (willDelete) {
        setShowPaymentModal(true);
  
      }
    });
  };
  const savePaymentModal = () => {
    setShowPaymentModal(false);
  };

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <LoggedHeader />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      {!loading && (
        <div className="container-fluid">
          <div className="subs-info p-4">
            <>
              <div className="subs-desc">
                <h2>
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_subscriber_info")
                        .length > 0
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_subscriber_info"
                        )[0]["value"] || "lbl_subscriber_info"
                      : "lbl_subscriber_info"
                    : "lbl_subscriber_info"}
                </h2>
              </div>
              <div className="row">
                <div className="col-xl-3 col-lg-2 col-lg-2-5 col-md-12">
                  <div className="sub-user-info mb-5 subsribe-info">
                    {auth?.user?.profile_pic ? (
                      <img
                        // src="assets/img1.jpg"
                        src={auth?.user?.profile_pic}
                        alt="sub-info"
                        className="text-center"
                      />
                    ) : (
                      <Skeleton
                        animation="wave"
                        variant="circular"
                        width={120}
                        height={120}
                      />
                    )}

                    <div className="subinfo-desc subsribe-info">
                      {auth?.user?.full_name ? (
                        <h2>{auth?.user?.full_name}</h2>
                      ) : (
                        <Skeleton
                          animation="wave"
                          width={80}
                          height={30}
                          className="mt-2"
                        />
                      )}

                      {subsDetails?.result?.dayssince ? (
                        <h6>{subsDetails?.result?.dayssince}</h6>
                      ) : (
                        <h6>0</h6> 
                      )}

                      <p>
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_no_days_left"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_no_days_left"
                              )[0]["value"] || "lbl_no_days_left"
                            : "lbl_no_days_left"
                          : "lbl_no_days_left"}
                      </p>
                      {/* <Link to="/subscription"> */}
                     {auth?.user?.dayssince==0 &&
                      <button
                        onClick={() => handleSubscribe(allSubscription?._id)}
                      >
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_renew_subs")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_renew_subs"
                              )[0]["value"] || "lbl_renew_subs"
                            : "lbl_renew_subs"
                          : "lbl_renew_subs"}
                      </button>
}
                      {/* </Link> */}
                    </div>
                  </div>
                </div>
                <div className="col-xl-9 col-lg-9 col-lg-9.5 col-md-12 margin-styles">
                  <div className="sub-desc-main col-lg-10 col-md-12">
                    <div className="dsx-sub-info d-flex align-items-center">
                      <div className="col-lg-4">
                        <h2>
                          {auth?.user?.full_name ? (
                            <strong>
                              {auth?.user?.full_name} :
                            </strong>
                          ) : (
                            <Skeleton animation="wave" width={80} height={30} />
                          )}
                        </h2>
                      </div>
                      <div className="col-lg-5">
                        <p>kt. {auth?.user?.ss_number}</p>
                      </div>
                    </div>
                    <div className="dsx-sub-info d-flex align-items-center">
                      <div className="col-lg-4">
                        <h2>
                          <strong>
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_email")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_email"
                                  )[0]["value"] || "lbl_email"
                                : "lbl_email"
                              : "lbl_email"}{" "}
                            :
                          </strong>
                        </h2>
                      </div>

                      <div className="col-lg-5">
                        {auth?.user?.email ? (
                          <p>{auth?.user?.email}</p>
                        ) : (
                          <Skeleton animation="wave" width={150} height={30} />
                        )}
                      </div>
                    </div>
                    <div className="dsx-sub-info d-flex align-items-center">
                      <div className="col-lg-4">
                        <h2>
                          <strong>
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_telephone"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_telephone"
                                  )[0]["value"] || "lbl_telephone"
                                : "lbl_telephone"
                              : "lbl_telephone"}{" "}
                            :
                          </strong>
                        </h2>
                      </div>
                      <div className="col-lg-5">
                        <p>{auth?.user?.mobile_number}</p>
                      </div>
                    </div>
                    <div className="dsx-sub-info d-flex align-items-center">
                      <div className="col-lg-4">
                        <h2>
                          <strong>
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_address")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_address"
                                  )[0]["value"] || "lbl_address"
                                : "lbl_address"
                              : "lbl_address"}{" "}
                            :
                          </strong>
                        </h2>
                      </div>
                      <div className="col-lg-4">
                        <p>{auth?.user?.address}</p>
                      </div>
                    </div>
                    <div className="dsx-sub-info d-flex align-items-center">
                      <div className="col-lg-4">
                        <h2>
                          <strong>
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_type_registering"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_type_registering"
                                  )[0]["value"] || "lbl_type_registering"
                                : "lbl_type_registering"
                              : "lbl_type_registering"}{" "}
                            :
                          </strong>
                        </h2>
                      </div>
                      <div className="col-lg-7">
                        {extraSubscriptionDetails?.register_type === 1 && (
                          <p>
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_electronic_id"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_electronic_id"
                                  )[0]["value"] || "lbl_electronic_id"
                                : "lbl_electronic_id"
                              : "lbl_electronic_id"}
                          </p>
                        )}
                        {extraSubscriptionDetails?.register_type === 2 && (
                          <p>
                     
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_phone_no"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_phone_no"
                                  )[0]["value"] || "lbl_phone_no"
                                : "lbl_phone_no"
                              : "lbl_phone_no"}
                          </p>
                        )}
                        {extraSubscriptionDetails?.register_type === 0 && (
                          <p>
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_by_admin"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_by_admin"
                                  )[0]["value"] || "lbl_by_admin"
                                : "lbl_by_admin"
                              : "lbl_by_admin"}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="sec-sub-info pt-3 mb-4">
                    <h2>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_subscription")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_subscription"
                            )[0]["value"] || "lbl_subscription"
                          : "lbl_subscription"
                        : "lbl_subscription"}
                    </h2>
                    <div className="part-to">
                      <div className="row">
                        <div className="col-lg-6 col-md-12">
                          <div className="sub-box-desc d-flex pt-3  align-items-center">
                            <div className="col-xl-9 col-lg-9 ">
                              <h3>
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_day_since_subs"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_day_since_subs"
                                      )[0]["value"] || "lbl_day_since_subs"
                                    : "lbl_day_since_subs"
                                  : "lbl_day_since_subs"}
                              </h3>
                            </div>
                            <div className="col-xl-3 col-lg-3 ">
                              <p>
                                {/* {moment(subsDetails?.result?.purchase_date)
                                  .startOf("days")
                                  .fromNow("days")
                                  .replace("days", "")} */}

                                {/* {
                                    moment(subsDetails?.result?.purchase_date).startOf("seconds").fromNow(true)
                                  } */}

                                {subsDetails?.result? getDays1(subsDetails?.result?.purchase_date):auth?.user?.dayssince}
                              </p>
                            </div>
                          </div>
                          <div className="sub-box-desc d-flex  align-items-center">
                            <div className="col-xl-9 col-lg-9">
                              <h3>
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_subs_valid_since"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_subs_valid_since"
                                      )[0]["value"] || "lbl_subs_valid_since"
                                    : "lbl_subs_valid_since"
                                  : "lbl_subs_valid_since"}
                              </h3>
                            </div>
                            <div className="col-xl-3 col-lg-3">
                              <p>
                                {subsDetails?.result?
                                 moment(
                                  subsDetails?.result?.purchase_date
                                ).format("DD/MM/YYYY") :   moment(
                                  auth?.user?.purchase_date
                                ).format("DD/MM/YYYY")}
                              </p>
                            </div>
                          </div>
                          <div className="sub-box-desc d-flex  align-items-center">
                            <div className="col-xl-9 col-lg-9">
                              <h3>
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_last_login_date"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_last_login_date"
                                      )[0]["value"] || "lbl_last_login_date"
                                    : "lbl_last_login_date"
                                  : "lbl_last_login_date"}
                              </h3>
                            </div>
                            <div className="col-xl-3 col-lg-3">
                              {extraSubscriptionDetails?.last_login ? (
                                <p>
                                  {moment(
                                    extraSubscriptionDetails?.last_login
                                  ).format("DD/MM/YYYY")}
                                </p>
                              ) : (
                                <p> --- </p>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="sec-sub-info pt-3">
                            <div className="sub-box-desc d-flex  align-items-center">
                              <div className="col-xl-9 col-lg-9">
                                <h3>
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_how_often_login"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_how_often_login"
                                        )[0]["value"] || "lbl_how_often_login"
                                      : "lbl_how_often_login"
                                    : "lbl_how_often_login"}
                                </h3>
                              </div>
                              <div className="col-xl-3 col-lg-3">
                                <p>
                                  {auth?.user?.loginTimes}
                                </p>
                              </div>
                            </div>
                            <div className="sub-box-desc d-flex  align-items-center">
                              <div className="col-xl-9 col-lg-9">
                                <h3>
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_no_of_ip"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_no_of_ip"
                                        )[0]["value"] || "lbl_no_of_ip"
                                      : "lbl_no_of_ip"
                                    : "lbl_no_of_ip"}
                                </h3>
                              </div>
                              <div className="col-xl-3 col-lg-3">
                                <p>
                                  {
                                    auth?.user?.ip_list
                                      ?.length
                                  }
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="sub-history-main">
                    <h2>
                      {frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_subscription_history"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_subscription_history"
                            )[0]["value"] || "lbl_subscription_history"
                          : "lbl_subscription_history"
                        : "lbl_subscription_history"}
                    </h2>
                    <p>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_ongoing_subs")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_ongoing_subs"
                            )[0]["value"] || "lbl_ongoing_subs"
                          : "lbl_ongoing_subs"
                        : "lbl_ongoing_subs"}
                    </p>
                    <div className="history-data mb-3">
                      <Table borderless responsive>
                        <thead>
                          <tr className="ongoing-table">
                            <th className="text-center">
                              {frontLabelsName
                                ? frontLabelsName.filter((e) => e.key == "lbl_no")
                                    .length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_num"
                                    )[0]["value"] || "lbl_num"
                                  : "lbl_num"
                                : "lbl_num"}
                            </th>
                            <th className="text-center">
                              {frontLabelsName
                                ? frontLabelsName.filter((e) => e.key == "lbl_date")
                                    .length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_date"
                                    )[0]["value"] || "lbl_date"
                                  : "lbl_date"
                                : "lbl_date"}
                            </th>
                            <th className="text-center">
                              {frontLabelsName
                                ? frontLabelsName.filter((e) => e.key == "lbl_type")
                                    .length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_type"
                                    )[0]["value"] || "lbl_type"
                                  : "lbl_type"
                                : "lbl_type"}
                            </th>
                            <th className="text-center">
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_amount"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_amount"
                                    )[0]["value"] || "lbl_amount"
                                  : "lbl_amount"
                                : "lbl_amount"}
                            </th>
                            <th className="text-center" >
                              { frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_cardholder_name")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_cardholder_name"
                          )[0]["value"] || "lbl_cardholder_name"
                        : "lbl_cardholder_name"
                      : "lbl_cardholder_name"}
                            </th>
                            <th className="text-center">
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_payment"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_payment"
                                    )[0]["value"] || "lbl_payment"
                                  : "lbl_payment"
                                : "lbl_payment"}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {subsDetails?.result ?
                              <tr className="text-color">
                              <td className="text-center">1</td>
                              <td className="text-center">
                                {moment(
                                  subsDetails?.result?.purchase_date
                                ).format("DD/MM/YYYY")}
                              </td>
                              <td className="text-center">Leigulistinn</td>
                              <td className="text-center">
                                {subsDetails?.result?.amount} kr
                              </td>
                              <td className="text-center">{subsDetails?.result?.trans?.card_holder_name ? subsDetails?.result?.trans?.card_holder_name :"N/A"}</td>
                              <td className="text-center" style={{paddingLeft:"0px",paddingRight:"0px"}}>{card_type ? card_type :
                                subsDetails?.result?.paid_type==1 ?
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_direct_bank_transfer"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_direct_bank_transfer"
                                      )[0]["value"] || "lbl_direct_bank_transfer"
                                    : "lbl_direct_bank_transfer"
                                  : "lbl_direct_bank_transfer":subsDetails?.result?.paid_type==2 ?  frontLabelsName
                                  ? frontLabelsName.filter((e) => e.key == "lbl_paid_by_cash")
                                      .length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_paid_by_cash"
                                      )[0]["value"] || "lbl_paid_by_cash"
                                    : "lbl_paid_by_cash"
                                  : "lbl_paid_by_cash" :
                                  frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_paid_with_card_at_office"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_paid_with_card_at_office"
                                      )[0]["value"] || "lbl_paid_with_card_at_office"
                                    : "lbl_paid_with_card_at_office"
                                  : "lbl_paid_with_card_at_office"
                              
                          }</td>
                            </tr> 
                            :
                            <tr className="text-color">
                                <td className="text-center" colSpan={6}>{frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_no_ongoing_subscription_found"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_no_ongoing_subscription_found"
                                    )[0]["value"] || "lbl_no_ongoing_subscription_found"
                                  : "lbl_no_ongoing_subscription_found"
                                : "lbl_no_ongoing_subscription_found"}</td>
                            </tr>
                          }
                      
                        </tbody>
                      </Table>
                    </div>
                    <p>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_all_subs")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_all_subs"
                            )[0]["value"] || "lbl_all_subs"
                          : "lbl_all_subs"
                        : "lbl_all_subs"}{" "}
                      :
                    </p>

                    <div className="all-sub-table-main">
                      <Table responsive borderless>
                        <thead>
                          <tr className="br-set-bottom text-center">
                            <th>
                              {frontLabelsName
                                ? frontLabelsName.filter((e) => e.key == "lbl_no")
                                    .length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_num"
                                    )[0]["value"] || "lbl_num"
                                  : "lbl_num"
                                : "lbl_num"}
                            </th>
                            <th>
                              {frontLabelsName
                                ? frontLabelsName.filter((e) => e.key == "lbl_date")
                                    .length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_date"
                                    )[0]["value"] || "lbl_date"
                                  : "lbl_date"
                                : "lbl_date"}
                            </th>
                            <th>
                              {frontLabelsName
                                ? frontLabelsName.filter((e) => e.key == "lbl_type")
                                    .length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_type"
                                    )[0]["value"] || "lbl_type"
                                  : "lbl_type"
                                : "lbl_type"}
                            </th>
                            <th>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_status"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_status"
                                    )[0]["value"] || "lbl_status"
                                  : "lbl_status"
                                : "lbl_status"}
                            </th>
                            <th>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_amount"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_amount"
                                    )[0]["value"] || "lbl_amount"
                                  : "lbl_amount"
                                : "lbl_amount"}
                            </th>
                            <th  style={{minWidth:"176px",lineHeight:1.1}}>
                              { frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_cardholder_name")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_cardholder_name"
                          )[0]["value"] || "lbl_cardholder_name"
                        : "lbl_cardholder_name"
                      : "lbl_cardholder_name"}
                            </th>
                            <th>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_payment"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_payment"
                                    )[0]["value"] || "lbl_payment"
                                  : "lbl_payment"
                                : "lbl_payment"}
                            </th>
                            <th style={{minWidth:"100px",lineHeight:1.1}}>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_card_no"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_card_no"
                                    )[0]["value"] || "lbl_card_no"
                                  : "lbl_card_no"
                                : "lbl_card_no"}
                            </th>
                       
                          </tr>
                        </thead>
                        <tbody>
                        
                          {!loading &&
                            rows.length > 0 ?
                            rows.map((sub, index) => {
                              return (
                                <tr
                                  className={`${
                                    sub?.status === 1 ? " " : "custom-dark "
                                  } set-fn-ddhdh text-center`}
                                >
                                  <td>{index + 1}</td>
                                  <td>
                                    {moment(sub?.purchase_date).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </td>
                                  <td>Leigulistinn</td>
                                  <td>
                                    {" "}
                                    {sub?.status === 1
                                      ? frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_active"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_active"
                                            )[0]["value"] || "lbl_active"
                                          : "lbl_active"
                                        : "lbl_active"
                                      : frontLabelsName
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_inactive"
                                        ).length > 0
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_inactive"
                                          )[0]["value"] || "lbl_inactive"
                                        : "lbl_inactive"
                                      : "lbl_inactive"}
                                  </td>
                                  <td>{sub?.amount} kr</td>
                                  <td  style={{width:"176px"}}>{  sub?.transactionsData?.card_holder_name ? sub?.transactionsData?.card_holder_name :"N/A"}</td>
                                  <td style={{paddingLeft:"0px",paddingRight:"0px"}}>
                                    { sub?.transactionsData?.payment_data
                                        ?.payment_method_data?.type ? InactiveCardType(
                                      sub?.transactionsData?.payment_data
                                        ?.payment_method_data?.type
                                    ): sub?.paid_type==1 ?
                                    frontLabelsName
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_direct_bank_transfer"
                                        ).length > 0
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_direct_bank_transfer"
                                          )[0]["value"] || "lbl_direct_bank_transfer"
                                        : "lbl_direct_bank_transfer"
                                      : "lbl_direct_bank_transfer":sub?.paid_type==2 ?  frontLabelsName
                                      ? frontLabelsName.filter((e) => e.key == "lbl_paid_by_cash")
                                          .length > 0
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_paid_by_cash"
                                          )[0]["value"] || "lbl_paid_by_cash"
                                        : "lbl_paid_by_cash"
                                      : "lbl_paid_by_cash" :
                                      frontLabelsName
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_paid_with_card_at_office"
                                        ).length > 0
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_paid_with_card_at_office"
                                          )[0]["value"] || "lbl_paid_with_card_at_office"
                                        : "lbl_paid_with_card_at_office"
                                      : "lbl_paid_with_card_at_office"}
                                    {/* Visa */}
                                  </td>
                                  <td className="lastcarddigit">
                                   { sub?.transactionsData?.payment_data
                                        ?.payment_method_data?.last4? "xxxxxxxxxxxx":"N/A"} 
                                    {
                                      sub?.transactionsData?.payment_data
                                        ?.payment_method_data?.last4
                                    }
                                  </td>
                                  {/* <td>view</td> */}
                                </tr>
                              );
                            }) :<tr className="set-fn-ddhdh text-center">
                             <td colSpan={8}>{frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_no_subscription_history_found"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_no_subscription_history_found"
                                    )[0]["value"] || "lbl_no_subscription_history_found"
                                  : "lbl_no_subscription_history_found"
                                : "lbl_no_subscription_history_found"}</td>
                            </tr> }
                     
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
          <div className="payment_modal">
            <PaymentModal
              showModal={showPaymentModal}
              closeModal={savePaymentModal}
              amount={allSubscription?.amount}
              id={allSubscription?._id}
              setRunningSub={setRunningSub}
            />
          </div>
        </div>
      )}
      {loading && <Loading />}
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  label: state.language,
});

export default connect(mapStateToProps, {
  runningSubscription,
  dashboardSubscription,
  getUserSubscription,
  getCardType,
  getAllSubscription,
})(Subscription_info);
